import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IPricingProfile, IPricingProfileForm } from './pricingProfile.interface';

export namespace PricingProfileAction {
  const actionCreator = actionCreatorFactory('PricingProfile');

  export const loadList = actionCreator.async<void, IPricingProfile[], IApiErrorParams>('LOAD_LIST');

  interface IPricingProfileCreateParams extends IPricingProfileForm, Pick<IResolverMeta, 'reject'> {}

  interface IPricingProfileUpdateParams extends IPricingProfileForm, Pick<IResolverMeta, 'reject'> {}

  export const create = actionCreator.async<IPricingProfileCreateParams, void, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<IPricingProfileUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ id: IPricingProfile['id'] }, void, IApiErrorParams>('REMOVE');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
